// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fO","advertDetailContacts__header":"c-o_fP"};